function heightResizer(objectFirst, objectSecond) {
    $(objectSecond).css("height", 'auto');
    var height = [];
    $(objectFirst).each(function (index) {
        height.push($(this).height());
    });
    var shopContainerMax = Math.min.apply(Math, height);
    $(objectSecond).css("height", shopContainerMax);

};

module.exports = function () {
    window.addEventListener('load', function(){
        heightResizer('.shop-container li img', '.shop-container li img');
        heightResizer('.products li > a > img', '.products li > a > img');
    });
    window.addEventListener('ready', function(){
        heightResizer('.shop-container li img', '.shop-container li img');
        heightResizer('.products li > a > img', '.products li > a > img');
    });
    window.addEventListener('resize', function(){
        heightResizer('.shop-container li img', '.shop-container li img');
        heightResizer('.products li > a > img', '.products li > a > img');
    });



    heightResizer('.shop-container li img', '.shop-container li img');
    heightResizer('.products li > a > img', '.products li > a > img');
};
